/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 *
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';
import dashboardBanner from '../images/footer-sherpas.png';
import theguy from '../images/just-the-guy-sm.png';
import Navigation from './Navigation.tsx';
import './DashboardHeroBanner.css';

interface DashboardHeroBannerProps {
  firstname?: string;
  lastname?: string;
  isAdmin: boolean;
  onLogoutClick: () => void;
}

// The top banner shown on every logged-in page: the trail image with the
// mascot + "Merch Sherpa $ales Portal" wordmark overlaid on the left (the
// site's original branding, previously in its own header bar above this
// image - merged in here so there's only one banner instead of two stacked
// ones), the desktop nav tabs overlapping its bottom-right corner, the
// logout button top-right, and an optional "Welcome, {name}" greeting
// bottom-left. The image itself is decorative (aria-hidden) and kept
// separate from the text so screen readers still read it.
const DashboardHeroBanner: React.FC<DashboardHeroBannerProps> = ({ firstname, lastname, isAdmin, onLogoutClick }) => {
  const fullName = [firstname, lastname]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className="dashboard-hero-banner-wrap">
        <div className="dashboard-hero-banner-clip">
          <div
            className="dashboard-hero-banner"
            style={{ backgroundImage: `url(${dashboardBanner})` }}
            aria-hidden="true"
          />
        </div>

        <button className="logout" onClick={onLogoutClick}>Logout</button>

        <div className="dashboard-hero-banner__brand">
          <img
            className="dashboard-hero-banner__mascot"
            src={theguy}
            alt="Merch Sherpa Cartoon"
          />
          <div className="relative">
            <div className="mouse mouse--white">Merch Sherpa <span>$</span>ales Portal</div>
            <div className="mouse">Merch Sherpa <span>$</span>ales Portal</div>
          </div>
        </div>

        {fullName && (
          <span className="dashboard-hero-banner__welcome">Welcome, {fullName}</span>
        )}

        <div className="dashboard-hero-banner__nav">
          <Navigation isAdmin={isAdmin} onLogoutClick={onLogoutClick} />
        </div>
      </div>
      <div className="dashboard-hero-banner__divider" />
    </>
  );
};

export default DashboardHeroBanner;
